import { render } from "./LandingPage.vue?vue&type=template&id=abd8c5a4&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=abd8c5a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-abd8c5a4"

export default script